import React, { ChangeEventHandler, PropsWithChildren } from "react";

import { SelectFieldOption } from "../lib/types";
import { clsx } from "clsx";
import { HelpBlock } from "../";

type Props = {
  label?: string;
  name?: string;
  title?: string;
  help?: string;
  req?: boolean;
  ref?: any;
  placeholder?: string;
  disabled?: boolean;
  asButton?: boolean;
  className?: string;
  dirty?: any;
  value: string | number;
  options: SelectFieldOption[];
  defaultedOption: boolean;
  onChange?: ChangeEventHandler<HTMLSelectElement>;
  getVState?: (v: string) => void;
};

const Select = ({
  label,
  name,
  title,
  help,
  req,
  ref,
  placeholder,
  disabled,
  asButton,
  className,
  dirty,
  value,
  options,
  onChange,
  defaultedOption,
  children,
  getVState,
  ...props
}: PropsWithChildren<Props>) => (
  <>
    {label && (
      <label>
        {label} {req && "*"}
      </label>
    )}

    <div
      className={clsx({
        "custom-select": true,
        "as-button": asButton,
        [`${className ? className : ""}`]: className,
        disabled: disabled,
      })}
    >
      <select
        {...props}
        disabled={disabled}
        name={name}
        value={value}
        className="form-control"
        onChange={onChange}
      >
        {(options.length !== 1 || defaultedOption) && (
          <option value="-1">{placeholder && placeholder}</option>
        )}

        {placeholder && options.length > 0 && <option value="" disabled selected>{placeholder}</option>}
        {options &&
          Array.isArray(options) &&
          options.map((option, _index) =>
            option.id === value ? (
              <option value={option.id} defaultValue={option.id} key={option.id}>
                {option.name || option.optionLabel}
              </option>
            ) : (
              <option value={option.id} key={option.id}>
                {option.name || option.optionLabel}
              </option>
            )
          )}

        {!options && children && children}
      </select>

      {help && <HelpBlock>{help}</HelpBlock>}
    </div>
  </>
);

export default Select;
